import * as React from "react";

const ROW_COUNT = 10;

export function ManageBookingsTableSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="h-[22px] w-1/3 max-w-[220px] rounded-[8px] bg-divider" />

      <div className="mt-[16px] rounded-[16px] border border-divider overflow-x-auto">
        <div className="min-w-full">
          <div className="grid grid-cols-8 gap-[12px] px-[16px] py-[14px]">
            {Array.from({ length: 8 }).map((_, i) => (
              <div
                key={i}
                className="h-[12px] w-2/3 rounded-[6px] bg-divider"
              />
            ))}
          </div>

          <div className="space-y-[10px] px-[16px] pb-[16px]">
            {Array.from({ length: ROW_COUNT }).map((_, i) => (
              <div
                key={i}
                className="grid grid-cols-8 gap-[12px] items-center rounded-[12px] bg-secondary/30 px-[12px] py-[14px]"
              >
                <div className="space-y-[8px]">
                  <div className="h-[12px] w-4/5 rounded-[6px] bg-divider" />
                  <div className="h-[10px] w-3/5 rounded-[6px] bg-divider" />
                </div>
                <div className="h-[12px] w-2/3 rounded-[6px] bg-divider" />
                <div className="h-[12px] w-3/4 rounded-[6px] bg-divider" />
                <div className="h-[12px] w-3/4 rounded-[6px] bg-divider" />
                <div className="h-[12px] w-1/2 rounded-[6px] bg-divider" />
                <div className="h-[12px] w-4/5 rounded-[6px] bg-divider" />
                <div className="h-[12px] w-2/3 rounded-[6px] bg-divider" />
                <div className="h-[32px] w-3/4 rounded-[10px] bg-divider" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
